import { Container } from 'react-bootstrap'

const About = () => {
  return (
    <Container style={{ height: '100vh' }}>
      <h2>This is about page</h2>
    </Container>
  )
}

export default About
